export default {
  lang: 'zh-TW',
  dir: 'ltr',
  common: {
    ok: '确定',
    cancel: '取消',
    key_backspace: '空白',
    key_del: '刪除',
    key_down: '下',
    key_up: '上',
    more_opts: 'More Options',
    url: 'URL',
    width: 'Width',
    height: 'Height'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: 'Show/hide more stroke tools',
    palette_info: '點擊更改填充顏色，按住Shift鍵單擊更改線條顏色',
    zoom_level: '更改縮放級別',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Identify the element',
    fill_color: '更改填充顏色',
    stroke_color: '線條顏色',
    stroke_style: '更改線條（虛線）風格',
    stroke_width: '線條寬度',
    pos_x: '調整 X 軸',
    pos_y: '調整 Y 軸',
    linecap_butt: 'Linecap: Butt',
    linecap_round: 'Linecap: Round',
    linecap_square: 'Linecap: Square',
    linejoin_bevel: 'Linejoin: Bevel',
    linejoin_miter: 'Linejoin: Miter',
    linejoin_round: 'Linejoin: Round',
    angle: '旋轉角度',
    blur: 'Change gaussian blur value',
    opacity: '更改所選項目不透明度',
    circle_cx: '改變圓的CX坐標',
    circle_cy: '改變圓的CY坐標',
    circle_r: '改變圓的半徑',
    ellipse_cx: '改變橢圓的圓心x軸座標',
    ellipse_cy: '改變橢圓的圓心y軸座標',
    ellipse_rx: '改變橢圓的x軸長',
    ellipse_ry: '改變橢圓的y軸長',
    line_x1: '更改行的起點的x坐標',
    line_x2: '更改行的終點x坐標',
    line_y1: '更改行的起點的y坐標',
    line_y2: '更改行的終點y坐標',
    rect_height: '更改矩形的高度',
    rect_width: '更改矩形的寬度',
    corner_radius: '角半徑：',
    image_width: '更改圖像的寬度',
    image_height: '更改圖像高度',
    image_url: '更改網址',
    node_x: '改變節點的x軸座標',
    node_y: '改變節點的y軸座標',
    seg_type: 'Change Segment type',
    straight_segments: '直線',
    curve_segments: '曲線',
    text_contents: '更改文字內容',
    font_family_label: 'Font:',
    font_family: '更改字體',
    font_size: '更改字體大小',
    bold: '粗體',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: '斜體',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Main Menu',
    bkgnd_color_opac: '更改背景顏色/不透明',
    connector_no_arrow: 'No arrow',
    fitToContent: '適合內容',
    fit_to_all: '適合所有的內容',
    fit_to_canvas: '適合畫布',
    fit_to_layer_content: '適合圖層內容',
    fit_to_sel: '適合選取的物件',
    align_relative_to: '相對對齊 ...',
    relativeTo: '相對於:',
    page: '網頁',
    largest_object: '最大的物件',
    selected_objects: '選取物件',
    smallest_object: '最小的物件',
    new_doc: '清空圖像',
    open_doc: '打開圖像',
    export_img: 'Export',
    save_doc: '保存圖像',
    import_doc: 'Import SVG',
    align_to_page: 'Align Element to Page',
    align_bottom: '底部對齊',
    align_center: '居中對齊',
    align_left: '向左對齊',
    align_middle: '中間對齊',
    align_right: '向右對齊',
    align_top: '頂端對齊',
    mode_select: '選擇工具',
    mode_fhpath: '鉛筆工具',
    mode_line: '線工具',
    mode_rect: 'Rectangle Tool',
    mode_square: 'Square Tool',
    mode_fhrect: '徒手畫矩形',
    mode_ellipse: '橢圓',
    mode_circle: '圓',
    mode_fhellipse: '徒手畫橢圓',
    mode_path: '路徑工具',
    mode_text: '文字工具',
    mode_image: '圖像工具',
    mode_zoom: '縮放工具',
    no_embed: 'NOTE: This image cannot be embedded. It will depend on this path to be displayed',
    undo: '取消復原',
    redo: '復原',
    tool_source: '編輯SVG原始碼',
    wireframe_mode: '框線模式（只瀏覽線條）',
    clone: 'Clone Element(s)',
    del: 'Delete Element(s)',
    group_elements: '群組',
    make_link: 'Make (hyper)link',
    set_link_url: 'Set link URL (leave empty to remove)',
    to_path: '轉換成路徑',
    reorient_path: '調整路徑',
    ungroup: '取消群組',
    docprops: '文件屬性',
    editor_homepage: 'SVG-Edit 主頁',
    move_bottom: '移至底部',
    move_top: '移動到頂部',
    node_clone: '增加節點',
    node_delete: '刪除節點',
    node_link: '將控制點連起來',
    add_subpath: 'Add sub-path',
    openclose_path: 'Open/close sub-path',
    source_save: '保存',
    cut: 'Cut',
    copy: 'Copy',
    paste: 'Paste',
    paste_in_place: 'Paste in Place',
    delete: 'Delete',
    group: 'Group',
    move_front: 'Bring to Front',
    move_up: 'Bring Forward',
    move_down: 'Send Backward',
    move_back: 'Send to Back',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: '圖層',
    layers: 'Layers',
    del: '刪除圖層',
    move_down: '向下移動圖層',
    new: '新增圖層',
    rename: '重新命名圖層',
    move_up: '向上移動圖層',
    dupe: 'Duplicate Layer',
    merge_down: 'Merge Down',
    merge_all: 'Merge All',
    move_elems_to: '移動物件到:',
    move_selected: '移動被點選的物件其他圖層'
  },
  config: {
    image_props: '圖片屬性',
    doc_title: '標題',
    doc_dims: '畫布大小',
    included_images: '包含圖像',
    image_opt_embed: '內嵌資料 (本地端檔案)',
    image_opt_ref: '使用檔案參照',
    editor_prefs: '編輯器屬性',
    language: '語言',
    background: '編輯器背景',
    editor_img_url: 'Image URL',
    editor_bg_note: '注意: 編輯器背景不會和圖像一起儲存',
    select_predefined: '使用預設值:',
    units_and_rulers: 'Units & Rulers',
    show_rulers: 'Show rulers',
    base_unit: 'Base Unit:',
    grid: 'Grid',
    snapping_onoff: 'Snapping on/off',
    snapping_stepsize: 'Snapping Step-Size:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: '數值給定錯誤',
    noContentToFitTo: '找不到符合的內容',
    dupeLayerName: '喔不！已經有另一個同樣名稱的圖層了！',
    enterUniqueLayerName: '請輸入一個名稱不重複的',
    enterNewLayerName: '請輸入新圖層的名稱',
    layerHasThatName: '圖層本來就是這個名稱（抱怨）',
    QmoveElemsToLayer: "要搬移所選取的物件到'%s'層嗎?",
    QwantToClear: '要清空圖像嗎？\n這會順便清空你的回復紀錄！',
    QwantToOpen: 'Do you want to open a new file?\nThis will also erase your undo history!',
    QerrorsRevertToSource: 'SVG原始碼解析錯誤\n要回復到原本的SVG原始碼嗎？',
    QignoreSourceChanges: '要忽略對SVG原始碼的更動嗎？',
    featNotSupported: '未提供此功能',
    enterNewImgURL: '輸入新的圖片網址',
    defsFailOnSave: 'NOTE: Due to a bug in your browser, this image may appear wrong (missing gradients or elements). It will however appear correct once actually saved.',
    loadingImage: 'Loading image, please wait...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Also note the following issues: ',
    unsavedChanges: 'There are unsaved changes.',
    enterNewLinkURL: 'Enter the new hyperlink URL',
    errorLoadingSVG: 'Error: Unable to load SVG data',
    URLLoadFail: 'Unable to load from URL',
    retrieving: 'Retrieving \'%s\' ...',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
